// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Da2eC","rootMobile":"styles_rootMobile__2DigI"};